import { removeNonDigits as c } from "./remove-non-digits.mjs";
const h = 35, M = ({
  value: e,
  mask: a,
  maskSymbol: r,
  allowMoreDigitsThanMaskAllows: g,
  offset: l = 0,
  trimNonMaskCharsLeftover: f = !1
}) => {
  if (e.length < l) return e;
  const p = e.slice(0, l), o = e.slice(l);
  let t = p, n = 0;
  for (const i of a.split("")) {
    if (n >= o.length) {
      if (!f && i !== r) {
        t += i;
        continue;
      }
      break;
    }
    i === r ? (t += o[n], n += 1) : t += i;
  }
  let s = c(t);
  return g && s.length < e.length && (t += e.slice(s.length), s = c(t)), s.length >= h && (t = t.slice(0, -(s.length - h) || void 0)), t;
};
export {
  M as applyMask
};
